var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGpxDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.719,
    height: 12.125,
    viewBox: "0 0 9.719 12.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-arrow_1_",
    "data-name": "download-arrow (1)",
    transform: "translate(-53.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1495",
    "data-name": "Group 1495",
    transform: "translate(53.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1521",
    "data-name": "Group 1521",
    fill: "#212547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M62.6,466.114H53.842a.486.486,0,0,0-.485.485v.647a.486.486,0,0,0,.485.485h8.75a.486.486,0,0,0,.485-.485V466.6A.478.478,0,0,0,62.6,466.114Z",
    transform: "translate(-53.357 -455.605)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M103.96,9.642a.484.484,0,0,0,.342.143.478.478,0,0,0,.342-.143l3.315-3.315a.488.488,0,0,0,0-.686l-.459-.459a.488.488,0,0,0-.686,0l-1.7,1.706V.485A.486.486,0,0,0,104.624,0h-.647a.484.484,0,0,0-.485.485v6.4l-1.706-1.706a.488.488,0,0,0-.686,0l-.459.459a.488.488,0,0,0,0,.686Z",
    transform: "translate(-99.438)",
    fill: "current"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpxDownload);
export default __webpack_public_path__ + "static/media/gpx-download.7c07de67e87cd54e36408cbbeb74e3d4.svg";
export { ForwardRef as ReactComponent };